<button
	(click)="menuOpened()"
	[class.active]="buttonIsActive"
	[class.selected]="filterValue?.label?.length"
	[matMenuTriggerFor]="filterMenu"
	[matMenuTriggerRestoreFocus]="false"
	class="applied-filter-btn"
	mat-flat-button
>
	<mat-icon
		[ngClass]="filter.icon"
		[svgIcon]="filter.icon"
		class="icon filter-type-icon"
	></mat-icon>
	<span class="filter-btn-text"
		>{{ filter.selectedFilter.name | translate }}:
		@for (label of filterValue?.label?.split('; '); track label; let last = $last) {
			{{ label | translate }}{{ !last ? '; ' : '' }}
		}
	</span>
	<mat-icon class="icon dropdown-icon" iconPositionEnd>arrow_drop_down</mat-icon>
	@if (!filter.selectedFilter.hideCloseButton) {
		<mat-icon (click)="removeFilter(filter)" class="icon close-icon" iconPositionEnd
			>close
		</mat-icon>
	}
</button>

<mat-menu
	#filterMenu="matMenu"
	(closed)="menuIsClosed()"
	class="cmms-applied-filter-menu"
	yPosition="below"
>
	<ng-template #filterTemplate></ng-template>
</mat-menu>

<ng-template #noFilterTemplate>
	<div class="no-filter-template no-data">Filter for this type is missing</div>
</ng-template>
